<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('table_label_material_category_no') || '分类编号'"
            prop="materialCategoryNo"
          >
            <el-input
              clearable
              v-model="formData.materialCategoryNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('table_label_material_category_name') || '分类名称'"
            prop="materialCategoryName"
          >
            <el-input
              clearable
              v-model="formData.materialCategoryName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="
              $l('table_label_material_category_name_En') || '分类英文名称'
            "
            prop="materialCategoryNameEn"
          >
            <el-input
              clearable
              v-model="formData.materialCategoryNameEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('table_label_classLevel') || '层级'"
            prop="classLevel"
          >
            <el-input
              clearable
              v-model="formData.classLevel"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item :label="$l('table_label_isLast') || '是否末级'">
            <el-col :span="24">
              <el-radio-group v-model="formData.isLast">
                <el-radio label="Y">{{
                  $l('table_label_isLast') || '是'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('table_label_noLast') || '否'
                }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item :label="$l('INDEX.Status') || '状态'">
            <el-col :span="24">
              <el-radio-group
                v-model="formData.materialCategoryStatus"
                :disabled="true"
              >
                <el-radio label="Y">{{
                  $l('INDEX.form_label_valid') || '有效'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('INDEX.form_label_invalid') || '无效'
                }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_created_by') || '创建人'"
            prop="createBy"
          >
            <el-input
              clearable
              v-model="formData.createBy"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_created_date') || '创建时间'"
            prop="createDate"
          >
            <el-input
              clearable
              v-model="formData.createDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modified_by') || '修改人'"
            prop="modifyBy"
          >
            <el-input
              clearable
              v-model="formData.modifyBy"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
            prop="modifyDate"
          >
            <el-input
              clearable
              v-model="formData.modifyDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    isadd: Boolean, //是否为添加功能
    materialCategoryCode: String,
    orgRow: {
      type: Object,
      default: () => {}
    },
    parentDep: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      regionShow: false,
      formData: { isLast: 'Y', materialCategoryStatus: 'Y', classLevel: 0 },
      rules: {
        materialCategoryNo: [
          {
            required: true,
            message:
              this.$l('table_please_input_material_category_no') ||
              '请输入分类编号',
            trigger: 'blur'
          }
        ],
        materialCategoryName: [
          {
            required: true,
            message:
              this.$l('table_please_input_material_category_name') ||
              '请输入分类名称',
            trigger: 'blur'
          }
        ],
        materialCategoryNameEn: [
          {
            required: true,
            message:
              this.$l('table_please_input_material_category_En') ||
              '请输入分类英文名称',
            trigger: 'blur'
          }
        ],
        classLevel: [
          {
            required: false,
            message: '请输入层级',
            trigger: 'blur'
          }
        ],
        isLast: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change'
          }
        ],
        materialCategoryStatus: [
          {
            required: false,
            message: '有效标志',
            trigger: 'change'
          }
        ],
        createBy: [
          {
            required: false,
            message: '请输入创建人',
            trigger: 'blur'
          }
        ],
        createDate: [
          {
            required: false,
            message: '请输入创建时间',
            trigger: 'blur'
          }
        ],
        modifyBy: [
          {
            required: false,
            message: '请输入修改人',
            trigger: 'blur'
          }
        ],
        modifyDate: [
          {
            required: false,
            message: '请输入修改时间',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    //console.log(typeof this.orgRow.classLevel)
    //console.log(this.formData.classLevel)
    if (this.isadd) {
      this.formData.classLevel = parseInt(this.orgRow.classLevel) + 1
    }
    //console.log(this.formData.classLevel)
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.materialCategoryCode) return
      this.$api
        .materialCategoryDetailApi({
          materialCategoryCode: this.materialCategoryCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      let params = { ...this.formData }
      if (!this.materialCategoryCode) {
        const { materialCategoryCode } = this.orgRow
        if (materialCategoryCode) {
          params = {
            ...this.formData,
            parentCode: materialCategoryCode,
            productLine: this.orgRow.productLine
          }
        }
      }
      this.loadingOpen()
      this.$api
        .materialCategorySaveApi(params)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
